<ng-select
  [clearable]="false"
  [virtualScroll]='true'
  class="cell-dropdown"
  bindLabel="value"
  bindValue="id"
  [(ngModel)]='selected'
  [searchable]="false"
  [items]='data.options'
  (change)='onSelect($event)'
  (open)='setDropdownStatus(false)'
  (close)='setDropdownStatus(true)'>
</ng-select>